var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("VueSkeletonLoader", {
    attrs: {
      type: _vm.type,
      width: _vm.width,
      height: _vm.height,
      animation: _vm.animation,
      color: _vm.bgColor,
      waveColor: _vm.waveColor,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }